$(document).ready(function() {
  let index_step  = 0;
  const form_url  = $('form.dreamform').attr('action');
  const form_name  = $('form.dreamform').attr('data-matomo-name');
  const container = $('.dreamform-step');
  const stepsmax  = $('.progress-bar').attr('aria-valuemax');
  _paq.push(['FormAnalytics::scanForForms']); // Init form scan for first step loaded by default
  //_paq.push(['FormAnalytics::enableDebugMode']);
  
  let isStepping = false;

  function showStep(stepNav) {
    // On the last step this POST renders tpl50_final, which creates the lead.
    // A second click while the first is in flight would create a second one.
    if(isStepping) {
      return;
    }
    isStepping = true;

    $("[name='nav-action']").val(stepNav);
    // Grab all data in step form
    const data = $('.steps').find("input, textarea");
    container.fadeTo(0, 0);
    $.ajax({
      url: form_url + '.json',
      method: 'POST',
      data: data.serialize(),
      dataType: 'json',
      cache: false,
      complete: function() {
        isStepping = false;
      },
      success: function(response) {
        container.html(response.tpl);
        handleCustomActions(response);
      },
      error: function(error) {
        console.error(error);
      }
    });
  }

  $(".next").click(function() {
    showStep('next');
  });

  $(".prev").click(function() {
    showStep('prev');
  });

  function handleCustomActions(response) {
    index_step = response.index;
    // Set index pagination
    $("[name='nav-idx']").val(index_step);
    let alert_commune = $('.alert_commune').length > 0 ? true:false;
    // If error commune
    if(index_step < 1) {
      if(alert_commune) {
        $(".prev").attr('disabled', false);
        $(".next").attr('disabled', true);
        $("#commune").css('display', 'none');
      }
      else {
        $(".prev").attr('disabled', true);
        $(".next").attr('disabled', false);
        $("#commune").css('display', 'block');
      }
    }
    // Disable prev button if step is first
    let next_status = index_step > 0 || alert_commune ? false:true;
    $(".prev").attr('disabled', next_status);
    // Rename next button if last step
    let next_label = index_step == stepsmax - 1 ? 'Valider':'Suivant';
    $(".next span").html(next_label);
    // Listen to click message in calendar
    document.addEventListener("chooseCall", function(){
      showStep('prev');
    });

    // Init current step
    window.Forms.init();

    var updatedElement = document.getElementById('dreamform');
    // If final step, push conversion
    if($('#form-result').length) {
      // because form does not have a submit button, we have to call both methods.
      _paq.push(['FormAnalytics::trackFormSubmit', document.getElementById(form_name)]);
      _paq.push(['FormAnalytics::trackFormConversion', document.getElementById(form_name)]);
      sendEventAction($('#form-result'), form_name);
    }
    // Else, target form wrapper, to scan form whose elements have changed
    else {
      _paq.push(['FormAnalytics::scanForForms', updatedElement]);
    }

    $('html, body').animate({ scrollTop: $('#dreamform').offset().top - 200 }, 0);
  }

  function sendEventAction(obj, form_name) {
    let action = obj.data('event-action');
    let cat    = obj.data('event-cat');
    let email  = obj.data('email');
    let params = {'event_category': cat,'event_label': action + '-ok'};
    _paq.push(['trackEvent', params.event_category, action, params.event_label]);
    if (typeof gtag == 'function') {
      if (email) {
        gtag('set', 'user_data', { 'email': email });
      }
      if(cat == 'formulaire-devis') {
        gtag('event', 'conversion', {'send_to': 'AW-10950972385/dW0nCPPrz9QaEOGn6uUo'});
        fbq('track', 'Lead', {content_name: 'form_devis'});
      }
      if(cat == 'formulaire-aides') {
        gtag('event', 'conversion', {'send_to': 'AW-10950972385/ipF6CIi45dQaEOGn6uUo'});
        fbq('track', 'Lead', {content_name: 'form_aides'});
      }
      if(cat == 'formulaire-rdv') {
        gtag('event', 'conversion', {'send_to': 'AW-10950972385/CfErCPnrz9QaEOGn6uUo'});
        fbq('track', 'Lead', {content_name: 'form_rdv'});
      }
    }
  }
});